export const localStorageKeys = {
  theme: "macaw-ui-theme",
  menuShrink: "macaw-ui-menu-shrink",
};
